import { useEffect } from 'react'; 
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const ServiceStatusDoughnutChart = ({ data }) => {

  const processing = data?.spTablero_GetCantProcesando_Result?.[0]?.CantProcesando ?? 0;
  const completed = data?.spTablero_GetCantFinalizados_Result?.[0]?.CantFinalizados ?? 0;
  const error = data?.spTablero_GetCantError_Result?.[0]?.CantError ?? 0;
  

  useEffect(() => {
    console.log("Actualizando gráfico con nuevos datos:", { processing, completed, error });
  }, [processing, completed, error]);

  const total = processing + completed + error;

  const chartData = {
    labels: ['Completado', 'Procesando', 'Error'],
    datasets: [
      {
        data: [completed, processing, error],
        backgroundColor: ['#28A745', '#FFC107', '#DC3545'],
        hoverBackgroundColor: ['#218838', '#E0A800', '#C82333'],
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom' },
      datalabels: {
        color: '#fff',
        font: { weight: 'bold', size: 14 },
        formatter: (value) => total > 0 ? `${((value / total) * 100).toFixed(1)}%` : '0%',
        anchor: 'center',
      },
    },
  };

  return (
    <div>
      <p style={{fontSize: 16, color: 'gray'}}>Procesando: {processing}</p>
      <p style={{fontSize: 16, color: 'gray'}}>Finalizados: {completed}</p>
      <p style={{fontSize: 16, color: 'gray'}}>Errores: {error}</p>
      <div style={{ width: '100%', height: '300px', minHeight: '200px' }}>
      {(processing === 0 && completed === 0 && error === 0) ? (
        <div>
        <br />
        <p>No hay datos suficientes para mostrar el gráfico.</p>
        </div>
        ) : (
            <Doughnut data={chartData} options={chartOptions} />
        )}
      </div>
    </div>
  );
};

export default ServiceStatusDoughnutChart;
